export default "__VITE_ASSET__DMqyk4Z7__"